export type Sortable = {
	direction: string;
	value: string;
};

export const SortableList: Sortable[] = [
	{ direction: 'asc', value: 'Accending' },
	{ direction: 'desc', value: 'Descending' },
];
